import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import { useContext, useState } from "react";
import Card from 'react-bootstrap/Card';
import countries from './countryNames-Ukrainian.json'
import information from './info2-Ukrainian.json'
import countries_en from './countryNames.json'
import information_en from './info2.json'
import links from './links.json'
import "./Information.scss"
import InputGroup from 'react-bootstrap/InputGroup';
import flights from './flights.jpeg'
const Information = () => {
const [info,setInfo] = useState({name:'',information:[],punkts:[],img:[]})
const [selectValue,setValue] = useState('')
const [error,serErr] = useState(true)
const [lang,setLang] = useState('ua')

const find = ()=>{
    if(lang=='ua'){

   let result = information.find(element => 
        element.name == selectValue
  );

    if(result == undefined){
        serErr(true)
      
    }else{
        serErr(false)
        setInfo(result)
    }
}else{
    let result = information_en.find(element => 
        element.name == selectValue
  );

    if(result == undefined){
        serErr(true)
      
    }else{
        serErr(false)
        setInfo(result)
    }
}
}


const handleChange = (e) => {
    setValue(e.target.value);
  };
  return (
    <div className='info'>
<Container style={{marginTop:"3%"}}>
    <Row >
    <Card.Img  src={flights}  style={{width:"90%",margin:"auto",marginTop:'2%',borderRadius:'2%'}}/> 
    </Row>
      <Row style={{width:"90%",margin:"auto"}}>
        <Col xs={4}>
            <InputGroup className="mb-3">
            
                <Form.Control
                placeholder={lang=='ua' ? 'Введіть країну' : 'Input country'}
                aria-label="Username"
                aria-describedby="basic-addon1"
                onChange={handleChange} 
                />
            </InputGroup>
        </Col>
        <Col xs={4}>
            <Form.Select aria-label="Оберіть країну"
             value={selectValue} 
             onChange={handleChange} 
            >
                <option>{lang=='ua' ? 'Оберіть країну' : 'Choose country'}</option>
               
                {lang=='ua' ? countries.map((el)=>(
            <option value={el}>{el}</option> 
                )
                      
                ):countries_en.map((el)=>(
                    <option value={el}>{el}</option> 
                        )
                              
                        )}
            </Form.Select>
        </Col>
        <Col xs={2}>
        <Button 
            variant="primary" 
            style={{ width: "100%"}}
            onClick={find}
            >
                {lang=='ua' ? 'Знайти' : 'Find'}
        </Button>
        </Col>
        <Col>
        <Form.Select aria-label="Default select example"
        value={lang} 
        onChange={(e)=>{
            setInfo({name:'',information:[],punkts:[],img:[]})
            setLang(e.target.value)
        }} 
        >
      <option>{lang=='ua' ? 'Мова' : 'Language'}</option>
      <option value="ua">{lang=='ua' ? 'Українська' : 'Ukrainian'}</option>
      <option value="en">{lang=='ua' ? 'Англійська' : 'English'}</option>
     
    </Form.Select>
        </Col>
      </Row>
      
    </Container>
    <h1 style={{textAlign:'center'}}>{info.name}</h1>
    {/* <Card.Img  src={mapUrl} style={{width:"30%"}} /> */}
    
<Container>
    {info.information.map((el,ind)=>(
         <Row className="row">
         <Col>
        
         <Card.Img  src={`https://www.pettravel.com/immigration/${info.img[ind]}`}  style={{width:"50%",marginLeft:'40%',marginTop:'10%'}}/> 

         </Col>
         <Col xs={10}>
                 <Card style={{ width: "100%" ,display:"flex"}}>
             <Card.Body>
               
                 <Card.Title>{ind+1}.{info.punkts[ind]} </Card.Title>
        
                 <Card.Subtitle className="mb-2 text-muted">Card Subtitle</Card.Subtitle>
                 <Card.Text>
                 {el}
                 </Card.Text>
                 <Card.Link href="#">Card Link</Card.Link>
                 <Card.Link href="#">Another Link</Card.Link>
             </Card.Body>
            
             </Card>
        </Col>
       </Row>
    ))}
     

    </Container>

     
    </div>
  )
}

export default Information